import { getUserCardProgram } from '@api/api'
import { queryOptions } from '@tanstack/react-query'

export const CARD_PROGRAM_QUERY_KEY = 'CARD_PROGRAM_QUERY_KEY'
export const cardProgramQueryOptions = queryOptions({
  queryKey: [CARD_PROGRAM_QUERY_KEY],
  queryFn: async () => {
    const response = await getUserCardProgram()
    return response.data
  },
})
